import _extends from 'babel-runtime/helpers/extends';

export default {
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  computed: {
    innerConfig: function innerConfig() {
      return _extends({ label: '标签', width: 120 }, this.config);
    }
  }
};